// @flow
import type { Element } from 'react';

import React from 'react';
import ComponentFormField from '#components/pages/Components/support/form/ComponentFormField/ComponentFormField.jsx';

type Props = {
  excludeInputGroup?: boolean,
  excludeLabel?: boolean,
  excludeTip?: boolean,
  item?: string | null,
  field: Object,
  readOnly?: boolean,
  render?: Function,
  visible: boolean,
};

const ComponentFormTableField = ({
  excludeInputGroup = false,
  excludeLabel = true,
  excludeTip = true,
  item = null,
  field,
  readOnly = false,
  render = null,
  visible,
}: Props): Element<typeof ComponentFormField> | Element<'div'> => {
  if (!visible) {
    return (
      <div className="text-center">
        <span>---</span>
      </div>
    );
  }
  return (
    <ComponentFormField
      excludeInputGroup={excludeInputGroup}
      excludeLabel={excludeLabel}
      excludeTip={excludeTip}
      field={field}
      item={item}
      readOnly={readOnly}
      render={render}
      visible
    />
  );
};

export default ComponentFormTableField;
